export enum CLICK_FROM {
    TOOLBAR = 'toolbar',
    TITLEBAR = 'titlebar',
    LEFTBAR = 'leftbar'
}
